import { Tooltip, TooltipProps } from "@mui/material";
import React from "react";

type SubmiticaTooltipProps = TooltipProps & SubmiticaTooltipStyleProps;

type SubmiticaTooltipStyleProps = {
  fontSize?: string;
  isCapitalised?: boolean;
  slotProps?: TooltipProps["slotProps"];
};

const SubmiticaTooltip = (props: SubmiticaTooltipProps) => {
  const baseSlotProps: TooltipProps["slotProps"] = {
    tooltip: {
      sx: {
        fontSize: props.fontSize ?? "0.8rem",
        textTransform: props.isCapitalised ? "capitalize" : "none"
      }
    }
  };

  return (
    <Tooltip
      placement={props.placement}
      title={props.title}
      slotProps={props.slotProps ? props.slotProps : baseSlotProps}
    >
      {props.children}
    </Tooltip>
  );
};

export default SubmiticaTooltip;
